module.exports = "/_next/static/images/b8e03322dcc1d2033291c7fd3833d0de-woman-with-iphone-short-form@0.5x.jpg";